import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  OrderCustomFieldsInput,
  OrderCustomFieldsMutation,
} from '@/gql/graphql';

const ORDER_CUSTOM_FIELDS_MUTATION = graphql(`
  mutation OrderCustomFields($input: OrderCustomFieldsInput!) {
    orderCustomFields(input: $input) {
      id
      role
      customFields {
        id
        identifier
        label
        type
        isRequired
        archivedAt
        options
        schema
        sortIndex
      }
    }
  }
`);

const useOrderCustomFields = (
  options?: UseMutationOptions<
    OrderCustomFieldsMutation,
    unknown,
    OrderCustomFieldsInput
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(ORDER_CUSTOM_FIELDS_MUTATION, {
        input,
      });
    },
    ...options,
  });
};

export default useOrderCustomFields;
